import { jsxs as I, jsx as c } from "react/jsx-runtime";
import { useEffect as h } from "react";
import { a as E, u as F } from "./chunks/index.esm-BFs3ABQ7.js";
import g from "./toRHFValidations.js";
import { tv as y } from "tailwind-variants";
import { M as C } from "./chunks/index-BehcGwHx.js";
const N = y({
  base: ["flex", "flex-col", "gap-1"]
}), b = ["CheckboxInput", "RadioInput", "ToggleInput"], k = ({
  defaultChecked: m,
  defaultValue: a,
  hasFocus: n,
  id: f,
  input: l,
  name: o,
  onChange: t,
  validations: e = {},
  value: i,
  wrapperClassName: x,
  ...d
}) => {
  const s = E(), u = b.includes(l.displayName);
  if (!s)
    throw new Error(
      "FormError: You can only use `InputWrapper` inside a `Form` component"
    );
  const { field: r } = F({
    name: o,
    control: s.control,
    defaultValue: u ? m : a,
    rules: g(e)
  });
  return h(() => {
    n && s.setFocus(o);
  }, []), /* @__PURE__ */ I("div", { className: N({ class: x }), children: [
    /* @__PURE__ */ c(
      l,
      {
        checked: u ? !!r.value : void 0,
        id: f,
        onBlur: r.onBlur,
        onChange: (p) => {
          r.onChange(p), t == null || t(p);
        },
        max: e.max,
        maxLength: e.maxLength,
        min: e.min,
        name: o,
        ref: r.ref,
        value: u ? i : r.value ?? "",
        ...d
      }
    ),
    e && /* @__PURE__ */ c(C, { name: o, validations: e, value: r.value })
  ] });
};
k.displayName = "InputWrapper";
export {
  k as default
};
